export default class MailSpamProtectionController {
  static mount() {
    MailSpamProtectionController.replaceInText(document.body,"\u2609","@");
  }

  static replaceInText(element : ChildNode, pattern : string, replacement : string) {
    for (let node of element.childNodes) {
      switch (node.nodeType) {
        case Node.ELEMENT_NODE:
          MailSpamProtectionController.replaceInText(node, pattern, replacement);
          break;
        case Node.TEXT_NODE:
          node.textContent = node.textContent.replaceAll(pattern, replacement);
          break;
        case Node.DOCUMENT_NODE:
          MailSpamProtectionController.replaceInText(node, pattern, replacement);
          break;
      }
    }
  }
}